import { TipoCosteGestionEnum, TipoSuministroTramiteEnergiaEnum, TipoTarifaEnergiaEnum, type ComisionEnergiaOfertaModel, type CoordenadaFirma, type CreateOfertaEnergiaModel, type DescuentoEnergiaModel, type DetailOfertaEnergiaModel, type OfertaGasModel, type OfertaLuzModel, type TerminoEnergia } from "@api/api";
import { DatosOfertaLuz } from "./DatosOfertaLuz";
import { DatosOfertaGas } from "./DatosOfertaGas";
import { toUTCDateOnly } from '@helpers/date-parser-helper';

export class CreateOfertaEnergia implements CreateOfertaEnergiaModel {

  IdEmpresaServicios: string = '';
  Nombre: string = '';
  CodigoTalonario: string | null = null;
  FechaInicio: Date = new Date();
  FechaFin: Date = new Date();
  TipoEnergia: TipoSuministroTramiteEnergiaEnum = TipoSuministroTramiteEnergiaEnum.Luz;
  TipoTarifa: TipoTarifaEnergiaEnum = TipoTarifaEnergiaEnum.Libre;
  TarifaAcceso: string = '2.0TD';
  AplicaPersonaFisica: boolean = false;
  AplicaPersonaJuridica: boolean = false;
  DatosLuz: OfertaLuzModel | null = null;
  DatosGas: OfertaGasModel | null = null;
  Observaciones: string = '';
  Activa: boolean = true; 
  CoordenadasFirma: CoordenadaFirma[] = [];
  RequiereRellenado: boolean = false;
  DenominacionInterna: string | null = null;
  Descuentos: DescuentoEnergiaModel[] = [];
  Comisiones: ComisionEnergiaOfertaModel[] = [];
  TipoCosteGestion: TipoCosteGestionEnum | null = null;
  CosteGestion: number | null = null;

  EmpresaServicios: string = '';

  constructor(data?: Partial<CreateOfertaEnergia>) {
    Object.assign(this, data);

    if (data?.FechaFin == null)
      this.FechaFin.setDate(this.FechaFin.getDate() + 1)

    this.FechaInicio = toUTCDateOnly(this.FechaInicio);
    this.FechaFin = toUTCDateOnly(this.FechaFin);


    if (this.TipoEnergia == TipoSuministroTramiteEnergiaEnum.Luz)
      this.DatosLuz = new DatosOfertaLuz();
    
    if (this.TipoEnergia == TipoSuministroTramiteEnergiaEnum.Gas)
      this.DatosGas = new DatosOfertaGas();

  }

  public createFromOfertaDetail(oferta: DetailOfertaEnergiaModel): CreateOfertaEnergia{
    Object.assign(this, oferta);
    return this;
  }
}



